export const TextNormalizer = {
    toUpperCase: (text: string): string => {
        return text.toUpperCase();
    },

    normalizeApostrophes: (text: string): string => {
        return text.replace(/[\u2018\u2019\u0060\u00B4\u2032]/g, "'");
    },

    normalizeWhitespace: (text: string): string => {
        return text.replace(/\s+/g, ' ');
    },

    trimWhitespace: (text: string): string => {
        return text.trim();
    },

    fullWidthToHalfWidth: (text: string): string => {
        let result = text.replace(/[\uFF01-\uFF5E]/g, (char) => {
            return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
        });
        result = result.replace(/\u3000/g, ' ');
        return result;
    },
};
